import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BarrierOpenModeEnum } from '@zaoblako/shared/modules/cctv/enums/barrier-open-mode.enum';
import { BarrierOpenModeEnumI18n } from '@zaoblako/shared/modules/cctv/i18n/barrier-open-mode-enum.i18n';

@Pipe({
  name: 'barrierOpenModeName',
  standalone: true
})
export class BarrierOpenModeNamePipe implements PipeTransform {
  public transform(status: BarrierOpenModeEnum): string {
    return BarrierOpenModeEnumI18n[I18nLocalesEnum.RU_RU][status] || '';
  }
}
